
/**
 * タブ
 */

import gsap from "gsap";

const tabFloorMapElectronic = () => {
  const tabBtns = document.querySelectorAll('.tab-trigger_floormap__electronic');

  for (let i = 0; i < tabBtns.length; i++) {
    tabBtns[i].addEventListener('click', tabSwitch, false);
  }

  const fadeIn = gsap.timeline({
    defaults: {
      duration: 3
    }
  });

  let flag = 0;
  const arraypanels = document.querySelectorAll('.tab-content-item_floormap__electronic');
  if (flag == 0) {
    gsap.set(arraypanels[0], {
      autoAlpha: 1,
      display: 'block'
    });
    flag = 1;
  }

  function tabSwitch(event) {
    event.preventDefault();

    document.querySelector('.is-active_floormap__electronic').classList.remove('is-active_floormap__electronic');
    this.classList.add('is-active_floormap__electronic');

    const arrayTabs = Array.prototype.slice.call(tabBtns);
    const index = arrayTabs.indexOf(this);
    const tabContent = document.querySelector('.tab-content-item_floormap__electronic:nth-child(' + (index + 1) + ')');

    arraypanels.forEach(tab => {
      gsap.set(tab, {
        autoAlpha: 0,
        display: 'none'
      });
    });

    /*連続クリック阻止*/
    for (let i = 0; i < tabBtns.length; i++) {
      tabBtns[i].style.pointerEvents = 'none';
    }
    setTimeout(() => {
      for (let i = 0; i < tabBtns.length; i++) {
        tabBtns[i].style.pointerEvents = 'auto';
      }
    }, 500);

    const tl = gsap.timeline();
    tl.fromTo(tabContent, {
      autoAlpha: 0
    }, {
      autoAlpha: 1,
      display: 'block',
      ease: 'power2.in'
    });
  }
};

export default tabFloorMapElectronic;